// The ||spoiler|| pill — component only; parsing/masking helpers live in
// spoilers.jsx (react-refresh wants component files to export only
// components).
//
// Reveal is TIMED (Haley: "only get revealed when clicked for like 5 seconds
// or something like that"): tap to show, and the bar closes itself again
// after REVEAL_MS — private lines don't sit exposed on a shared screen. The
// hidden state double-guards the content — transparent color on the pill AND
// opacity 0 on the children — so nested formatting (bold, emoji, even
// images) stays invisible, and user-select is off so it can't be copied out
// while hidden.

import React, { useEffect, useRef, useState } from 'react';
import { REVEAL_MS } from './spoilers.jsx';

export default function Spoiler({ children }) {
  const [revealed, setRevealed] = useState(false);
  const hideTimerRef = useRef(null);
  useEffect(() => () => clearTimeout(hideTimerRef.current), []);
  const reveal = (e) => {
    if (revealed) return;
    e.stopPropagation();
    e.preventDefault();
    setRevealed(true);
    clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => setRevealed(false), REVEAL_MS);
  };
  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={revealed ? 'spoiler, revealed' : 'spoiler — tap to reveal'}
      onClick={reveal}
      onPointerDown={revealed ? undefined : (e) => e.stopPropagation()}
      onKeyDown={(e) => { if (!revealed && (e.key === 'Enter' || e.key === ' ')) reveal(e); }}
      style={revealed ? {
        background: 'rgba(255,255,255,0.09)',
        borderRadius: '4px',
        padding: '0 3px',
      } : {
        background: '#0b0c0f',
        color: 'transparent',
        borderRadius: '4px',
        padding: '0 3px',
        cursor: 'pointer',
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }}
    >
      {revealed
        ? children
        : <span aria-hidden="true" style={{ opacity: 0, pointerEvents: 'none' }}>{children}</span>}
    </span>
  );
}
